/* ==========================================================================
 *  Function: range_slider
 * ======================================================================= */
var rangeSlider;
function fn_components_range_slider(){
	if ($( '.js-range-slider' ).length){
		var $range = $( '.js-range-slider-price' ),
			$from = $( '.js-price-value' ),
			min = 0,
			max = 2000,
			from,
			to;

		var updateValues = function () {
			$from.text( from + '€-'+ to +'€' );
		};

		$range.ionRangeSlider({
			type: 'double',
			from: 0,
			grid: false,
			force_edges: true,
			hide_min_max: true,
			hide_from_to: true,
			onChange: function (data) {
				from = data.from;
				to = data.to;
				updateValues();
				checkFilterItems();
			}
		});

		rangeSlider = $range.data( 'ionRangeSlider' );
	}
}

